module.exports = __webpack_public_path__ + "static/img/Bachelor_010413.2f33722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010413.jpg
// module id = 162
// module chunks = 0